import { risingCardMotion, type FlowThemeCardMotion } from '../../cardMotion';

/** Cards rise up and away like released lanterns. */
export const lanternsCardMotion = (isMobile: boolean): FlowThemeCardMotion => risingCardMotion(isMobile, 80, 6);
